export const distinct = <T>(array: T[]) => [].concat(...new Set(array));
